export default "<div class=\"orders-map\">\n  <div #map class=\"map\"></div>\n</div>\n"